export default selector => {
    if ('undefined' === typeof selector) {
        selector = '.lazy';
    }
    const lazyLoadInstance = new LazyLoad({
        elements_selector: selector
    })
}
